<template lang="pug">
div
  el-row
    el-col(:sm="24")
      p.info Data do cadastro:
        span {{documento.dataCriacao}}
    el-col(:sm="24")
      p.info Número do Ofício:
        span {{documento.numeroOficio}}
    el-col(:sm="24")
      p.info Protocolo:
        span {{documento.protocolo}}
    slot(name="baixar")

    el-row.dados-doc
      .link-download
        font-awesome-icon(icon="cloud-download-alt")
        a(@click="downloadDoc(documento.id)") &nbsp Baixar Documento

</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  mixins: [
    AppNotificacao
  ],
  async created () {
    if (_.isEmpty(this.documento)) { // eslint-disable-line
      await this.consultaDocumento(this.$route.params.protocolo)
    }
  },
  computed: {
    ...mapGetters({
      documento: 'documentosAutenticaveis/item'
    })
  },

  methods: {
    ...mapActions({
      consultaDocumento: 'documentosAutenticaveis/consultaAutenticidade',
      baixarDocumento: 'documentosAutenticaveis/download'
    }),
    downloadDoc (id) {
      this.baixarDocumento(id)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/_variables.scss";
.info {
  font-weight: bold;
  font-size: 16px;
  margin: 10px 0 5px 0;
}
.title {
  font-size: 25px;
}
span {
  font-weight: normal;
  margin-left: 5px;
}
.link-download, a {
  margin-top: 15px;
  color: $color-primary;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    color: #33b281;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/OficioArrecadacao.vue